import { render } from "./AwaitModal.vue?vue&type=template&id=3f7d1108&ts=true"
import script from "./AwaitModal.vue?vue&type=script&lang=ts"
export * from "./AwaitModal.vue?vue&type=script&lang=ts"

import "./AwaitModal.vue?vue&type=style&index=0&id=3f7d1108&lang=scss"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__